export default __webpack_public_path__ + "static/media/cloth_09.4e07657a.jpg";